/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  IconButton,
} from "@mui/material"; // Material-UI components

import CloseIcon from "@mui/icons-material/Close";

// Dashboard example components
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";

// Functions from store
import { getFg, getGrnReportHome } from "../../store";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import { da } from "date-fns/locale";
import ReportsLineChartPop from "examples/Charts/LineCharts/ReportsLineChart copy";
import ChartWithRange from "./ChartWithRange";

import Cookies from "universal-cookie";

const cookies = new Cookies();

const GrnHomePageCard = ({
  getGrnReportHome,
  getGrnReportHomeReducer,
  startDate,
  endDate,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let role = loginDetails.data.role;

  let jwtToken = loginDetails?.jwt;

  const startDateIso = startDate ? startDate.toISOString().slice(0, 10) : "";

  const endDateIso = endDate ? endDate.toISOString().slice(0, 10) : "";

  useEffect(() => {
    getGrnReportHome(startDateIso, endDateIso, jwtToken);
  }, [startDateIso, endDateIso]);

  const [grnData, setGrnData] = useState([]);

  const [grnTitle, setGrnTitle] = useState("");

  useEffect(() => {
    let data = getGrnReportHomeReducer.grn.data
      ? getGrnReportHomeReducer.grn.data.grnData
      : [];

    setGrnData(data);
    console.log(data);
    setGrnTitle(getGrnReportHomeReducer?.grn?.data?.reportTitle);
  }, [getGrnReportHomeReducer]);

  const chartData = {
    labels: grnData.map((d) => d.label),
    datasets: {
      label: "Total GRN Count",
      data: grnData.map((d) => d.totalGrnCount),
    },
  };

  const [open, setOpen] = useState(false); // State for managing dialog visibility

  const handleOpen = () => {
    setOpen(true);
  };

  // Close the dialog
  const handleClose = () => {
    setOpen(false);
  };

  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const styles = {
    iconButton: {
      marginLeft: "10px",
      padding: "12px",
      borderRadius: "50%",
      backgroundColor: isHovered ? "#28a745" : "#34b933", // Green background (hover state is darker)
      color: "white",
      boxShadow: isFocused
        ? "0 0 0 4px rgba(38, 143, 255, 0.5)" // Focus ring
        : "0 4px 12px rgba(0, 123, 255, 0.3)", // Default shadow
      transition: "all 0.3s ease-in-out", // Smooth transition for hover/scale/focus
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transform: isHovered ? "scale(1.1)" : "scale(1)", // Scale effect on hover
    },
  };
  return (
    <>
      <ReportsLineChart
        color="success"
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <span
              style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}
            >
              {grnTitle}
            </span>
            <IconButton
              style={styles.iconButton}
              onClick={handleOpen}
              onMouseEnter={() => setIsHovered(true)} // Hover effect (onMouseOver to onMouseEnter)
              onMouseLeave={() => setIsHovered(false)} // Hover effect (onMouseOut to onMouseLeave)
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              aria-label="Home"
            >
              <AspectRatioIcon />
            </IconButton>
          </div>
        }
        chart={chartData}
      />

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            width: "95%",
            maxWidth: "100%",
            height: "100vh",
            margin: "auto",
            overflow: "hidden", // Prevent scrollbars
          },
        }}
      >
        <DialogTitle
          sx={{
            position: "relative", // Ensure that the close button can be positioned absolutely
          }}
        >
          {grnTitle}
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {/* Indicator Boxes */}
            <div style={{ display: "flex", gap: "12px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <div
                  style={{
                    width: 18,
                    height: 18,
                    background: "#34b933", // GRN Count
                    borderRadius: 4,
                    border: "1px solid #ccc",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  title="GRN Count"
                />
                <span style={{ fontSize: 13 }}>GRN Count</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <div
                  style={{
                    width: 18,
                    height: 18,
                    background: "#ff0000", // Printed GRN
                    borderRadius: 4,
                    border: "1px solid #ccc",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  title="Printed GRN"
                />
                <span style={{ fontSize: 13 }}>Printed GRN</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <div
                  style={{
                    width: 18,
                    height: 18,
                    background: "#006effff", // Putaway GRN
                    borderRadius: 4,
                    border: "1px solid #ccc",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  title="Putaway GRN"
                />
                <span style={{ fontSize: 13 }}>Putaway GRN</span>
              </div>
            </div>
          </div>

          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 4,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            flex: 1,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* ⬇️ Your Chart */}
          <Box
            mb={2}
            width="100%"
            sx={{
              flex: 1,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <ChartWithRange />
          </Box>
        </DialogContent>

        <DialogActions>
          {/* <Button onClick={handleClose} color="primary">
            Close
          </Button> */}
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getGrnReportHomeReducer: state.getGrnReportHomeReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getGrnReportHome: (startDate, endDate, jwtToken) =>
      dispatch(getGrnReportHome(startDate, endDate, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GrnHomePageCard);
